import { useToast } from "../../hooks/use-toast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "./toast"

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider>
      {toasts.length > 0 && toasts[0] && (
        <Toast key={toasts[0].id} {...toasts[0]}>
          <div className="grid gap-1">
            {toasts[0].title && <ToastTitle>{toasts[0].title}</ToastTitle>}
            {toasts[0].description && (
              <ToastDescription>{toasts[0].description}</ToastDescription>
            )}
          </div>
          {toasts[0].action}
          <ToastClose />
        </Toast>
      )}
      <ToastViewport />
    </ToastProvider>
  );
}
